import React from 'react';
import PropTypes from 'prop-types';

export const Footer = ({ position = 'static' }) => {
  return (
    <>
      <footer
        className={`mt-16 text-center text-sm text-gray-500 global_footer ${
          position === 'absolute' ? 'absolute' : 'static'
        }`}
      >
        © {new Date().getFullYear()} Quiz Maker AI. All rights reserved.
      </footer>
    </>
  );
};

Footer.propTypes = {
  position: PropTypes.oneOf(['static', 'absolute']),
};